import React from 'react';
const AboutPage =()=>{
    return(
        <>
    <h1 className='abtPage'> Coming Soon..</h1>
       
        </>
    )
}
export default AboutPage;